import { motion } from 'framer-motion'
import React from 'react'

import { getAnimationParams } from '../../helpers/animations'
import { getStringFromJSX } from '../../helpers/getStringFromJSX'
import CollectionVideo from '../UI/CollectionVideo/CollectionVideo'
import { NewBackButton } from '../UI/NewBackButton/NewBackButton'
import styles from './InnerHero.module.scss'
import { InnerHeroProps } from './InnerHero.types'

export function InnerHero(props: InnerHeroProps) {
  const { title, text, image, video, classModifiers = [] } = props

  return (
    <section className={`section ${styles.InnerHero}`}>
      <motion.div {...getAnimationParams(-700)} className={styles.leftSide}>
        <div className={styles.back}>
          <NewBackButton />
        </div>
        <h1 style={{ whiteSpace: 'pre-wrap' }}>{title}</h1>
        <p style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
      </motion.div>
      <motion.div className={styles.rightSide} {...getAnimationParams(800)}>
        {video ? (
          <CollectionVideo props={video} />
        ) : (
          <img src={image} alt={getStringFromJSX(title)} />
        )}
      </motion.div>
    </section>
  )
}
